import {
  GENDER,
  analyzePillars,
  collectNatalShenSha,
  packPillar,
  shenShaNames,
} from 'bazi-lite';

const stems = '甲乙丙丁戊己庚辛壬癸';
const branches = '子丑寅卯辰巳午未申酉戌亥';

function pack(text) {
  return packPillar(stems.indexOf(text[0]), branches.indexOf(text[1]));
}

globalThis.BaziLite = Object.freeze({
  shenSha(pillars, gender) {
    const chart = analyzePillars({
      year: pack(pillars[0]),
      month: pack(pillars[1]),
      day: pack(pillars[2]),
      hour: pack(pillars[3]),
    });
    const values = collectNatalShenSha(chart, {
      gender: gender === '女' ? GENDER.FEMALE : GENDER.MALE,
    });
    return ['year', 'month', 'day', 'hour'].map((key) => [...shenShaNames(values[key])]);
  },
});
